/* PDP Quantity buttons */
(function () {
  function onQuantityButtonClick(e) {
    const btn = e.target.closest('[data-quantity] .quantity__button');
    if (!btn) return;

    const wrap = btn.closest("[data-quantity]");
    const input = wrap.querySelector('input[name="quantity"]');
    if (!input) return;

    const min = parseInt(input.getAttribute("min") || "1", 10);
    const maxAttr = input.getAttribute("max");
    const max = maxAttr ? parseInt(maxAttr, 10) : null;
    const step = parseInt(input.getAttribute("step") || "1", 10);

    const current = parseInt(input.value || "1", 10) || min;
    let next = current;

    if (btn.name === "minus") next = current - step;
    if (btn.name === "plus") next = current + step;

    if (next < min) next = min;
    if (max !== null && next > max) next = max;

    input.value = String(next);

    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));

    e.preventDefault();
  }

  document.addEventListener("click", onQuantityButtonClick, true);
})();